import { Text } from '@fluentui/react';
import { ECompareVMStatus, EMergeVMStatus, EMergeAction_FriendlyLabels } from 'global/Compare/ComparisonViewModelGenerator';
import React, { CSSProperties } from 'react';


interface MergeStatusIndicatorProps {
    mergeStatus: EMergeVMStatus;
    compareStatus?: ECompareVMStatus;
    isMergeApp?: boolean;
}

const CONTAINER_STYLE: CSSProperties = {
    display: 'inline-flex',
    marginRight: '5px',
    width: '260px',
    userSelect: 'none',
    cursor: 'default',
}

const COMPARE_LABELS_BY_STATUS: Record<ECompareVMStatus, string> = {
    [ECompareVMStatus.Unknown]: 'Unknown',
    [ECompareVMStatus.Identical]: 'Identical',
    [ECompareVMStatus.Modified]: 'Modified',
    [ECompareVMStatus.OnTargetOnly]: 'On Target Only',
    [ECompareVMStatus.OnOriginOnly]: 'On Origin Only',
};


const CompareMergeStatusIndicator: React.FC<MergeStatusIndicatorProps> = (props) => {

    const mergeTitle = EMergeAction_FriendlyLabels[props.mergeStatus];
    const compareTitle = COMPARE_LABELS_BY_STATUS[props.compareStatus ?? ECompareVMStatus.Unknown];

    return (
        <div style={CONTAINER_STYLE}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <Text variant='small' styles={{
                    root: {
                        textTransform: 'uppercase',
                        borderBottom: '1px solid #44444469',
                        width: '100%',
                    }
                }}>
                    <span style={{ width: '68px', display: 'inline-block', fontWeight: 'bold', textAlign: 'right', marginRight: '4px' }}>
                        COMPARE:
                    </span>
                    {compareTitle}
                </Text>

                {props.isMergeApp &&
                    <Text variant='small' styles={{
                        root: {
                            textTransform: 'uppercase',
                        }
                    }}>
                        <span style={{ width: '68px', display: 'inline-block', fontWeight: 'bold', textAlign: 'right', marginRight: '4px' }}>
                            MERGE:
                        </span>
                        {mergeTitle}
                    </Text>
                }

            </div>
        </div>
    );
};

export default CompareMergeStatusIndicator;
